import usfLogo from '../logos/usf.png';
import ucfLogo from '../logos/ucf.png';
import ufLogo from '../logos/uf.png';
import nyuLogo from '../logos/nyu.png';
import uwLogo from '../logos/uw.png';
import uclaLogo from '../logos/ucla.png';
import calLogo from '../logos/cal.png';
import fauLogo from '../logos/fau.png';
import fiuLogo from '../logos/fiu.png';
import fsuLogo from '../logos/fsu.png';
import umLogo from '../logos/um.png';
import buLogo from '../logos/bu.png';
import famuLogo from '../logos/famu.png';
import fgcuLogo from '../logos/fgcu.png';
import unfLogo from '../logos/unf.png';
import asuLogo from '../logos/asu.png';
import auburnLogo from '../logos/auburn.png';
import csufLogo from '../logos/csuf.png';
import csulbLogo from '../logos/csulb.png';
import cmuLogo from '../logos/cmu.png';
import cunyLogo from '../logos/cuny.png';
import clemsonLogo from '../logos/clemson.png';
import csuLogo from '../logos/csu.png';
import columbiaLogo from '../logos/columbia.png';
import cornellLogo from '../logos/cornell.png';
import dukeLogo from '../logos/duke.png';
import gmuLogo from '../logos/gmu.png';
import gatechLogo from '../logos/gatech.png';
import gsuLogo from '../logos/gsu.png';
import harvardLogo from '../logos/harvard.png';
import ilstuLogo from '../logos/ilstu.png';
import iuLogo from '../logos/iu.png';
import iastateLogo from '../logos/iastate.png';
import lsuLogo from '../logos/lsu.png';
import mitLogo from '../logos/mit.png';
import miamiohLogo from '../logos/miamioh.png';
import msuLogo from '../logos/msu.png';
import ncsuLogo from '../logos/ncsu.png';
import northeasternLogo from '../logos/northeastern.png';
import northwesternLogo from '../logos/northwestern.png';
import osuLogo from '../logos/osu.png';
import oregonstateLogo from '../logos/oregonstate.png';
import pennstateLogo from '../logos/pennstate.png';
import purdueLogo from '../logos/purdue.png';
import ritLogo from '../logos/rit.png';
import rutgersLogo from '../logos/rutgers.png';
import sdsuLogo from '../logos/sdsu.png';
import stanfordLogo from '../logos/stanford.png';
import sunyLogo from '../logos/suny.png';
import syracuseLogo from '../logos/syracuse.png';
import templeLogo from '../logos/temple.png';
import tamuLogo from '../logos/tamu.png';
import txstLogo from '../logos/txst.png';
import uaLogo from '../logos/ua.png';
import arizonaLogo from '../logos/arizona.png';
import ucdavisLogo from '../logos/ucdavis.png';
import uciLogo from '../logos/uci.png';
import ucsdLogo from '../logos/ucsd.png';
import uchicagoLogo from '../logos/uchicago.png';
import ucincinnatiLogo from '../logos/ucincinnati.png';
import coloradoLogo from '../logos/colorado.png';
import uconnLogo from '../logos/uconn.png';
import udelLogo from '../logos/udel.png';
import ugaLogo from '../logos/uga.png';
import uhLogo from '../logos/uh.png';
import uiucLogo from '../logos/uiuc.png';
import uicLogo from '../logos/uic.png';
import uiowaLogo from '../logos/uiowa.png';
import kuLogo from '../logos/ku.png';
import umdLogo from '../logos/umd.png';
import umassLogo from '../logos/umass.png';
import umichLogo from '../logos/umich.png';
import umnLogo from '../logos/umn.png';
import missouriLogo from '../logos/missouri.png';
import unlLogo from '../logos/unl.png';
import uncLogo from '../logos/unc.png';
import untLogo from '../logos/unt.png';
import ouLogo from '../logos/ou.png';
import uoregonLogo from '../logos/uoregon.png';
import upennLogo from '../logos/upenn.png';
import pittLogo from '../logos/pitt.png';
import scLogo from '../logos/sc.png';
import uscLogo from '../logos/usc.png';
import utkLogo from '../logos/utk.png';
import utexasLogo from '../logos/utexas.png';
import virginiaLogo from '../logos/virginia.png';
import wiscLogo from '../logos/wisc.png';
import vanderbiltLogo from '../logos/vanderbilt.png';
import vtLogo from '../logos/vt.png';
import wsuLogo from '../logos/wsu.png';
import wayneLogo from '../logos/wayne.png';
import uwfLogo from '../logos/uwf.png';
import floridapolyLogo from '../logos/floridapoly.png';
import novaLogo from '../logos/nova.png';
import erauLogo from '../logos/erau.png';
import floridatechLogo from '../logos/floridatech.png';
import utampaLogo from '../logos/utampa.png';
import rollinsLogo from '../logos/rollins.png';
import stetsonLogo from '../logos/stetson.png';
import ncfLogo from '../logos/ncf.png';
import barryLogo from '../logos/barry.png';
import eckerdLogo from '../logos/eckerd.png';
import bcuLogo from '../logos/bcu.png';
import flsouthernLogo from '../logos/flsouthern.png';
import lynnLogo from '../logos/lynn.png';
import pbaLogo from '../logos/pba.png';
import stuLogo from '../logos/stu.png';
import ringlingLogo from '../logos/ringling.png';
import avemariaLogo from '../logos/avemaria.png';
import fordhamLogo from '../logos/fordham.png';
import paceLogo from '../logos/pace.png';
import stonybrookLogo from '../logos/stonybrook.png';
import buffaloLogo from '../logos/buffalo.png';
import binghamtonLogo from '../logos/binghamton.png';
import ualbanyLogo from '../logos/ualbany.png';
import hofstraLogo from '../logos/hofstra.png';
import stjohnsLogo from '../logos/stjohns.png';
import prattLogo from '../logos/pratt.png';
import newschoolLogo from '../logos/newschool.png';
import fitnycLogo from '../logos/fitnyc.png';
import yeshivaLogo from '../logos/yeshiva.png';
import barnardLogo from '../logos/barnard.png';
import cooperunionLogo from '../logos/cooperunion.png';
import svaLogo from '../logos/sva.png';
import rpiLogo from '../logos/rpi.png';
import colgateLogo from '../logos/colgate.png';
import vassarLogo from '../logos/vassar.png';
import hamiltonLogo from '../logos/hamilton.png';
import skidmoreLogo from '../logos/skidmore.png';
import bardLogo from '../logos/bard.png';
import unioncollegeLogo from '../logos/unioncollege.png';
import ithacaLogo from '../logos/ithaca.png';
import maristLogo from '../logos/marist.png';
import adelphiLogo from '../logos/adelphi.png';
import liuLogo from '../logos/liu.png';
import nyitLogo from '../logos/nyit.png';
import mercyLogo from '../logos/mercy.png';
import manhattanunivLogo from '../logos/manhattanuniv.png';
import sarahlawrenceLogo from '../logos/sarahlawrence.png';
import stevensLogo from '../logos/stevens.png';
import princetonLogo from '../logos/princeton.png';
import njitLogo from '../logos/njit.png';
import setonhallLogo from '../logos/setonhall.png';
import yaleLogo from '../logos/yale.png';
import fairfieldLogo from '../logos/fairfield.png';

export const UNIVERSITY_LOGOS: { [key: string]: string } = {
    // Abbreviations
    'USF': usfLogo,
    'UCF': ucfLogo,
    'UF': ufLogo,
    'NYU': nyuLogo,
    'UW': uwLogo,
    'UCLA': uclaLogo,
    'UCBerkeley': calLogo,
    'CAL': calLogo,
    'FAU': fauLogo,
    'FIU': fiuLogo,
    'FSU': fsuLogo,
    'UM': umLogo,
    'BU': buLogo,
    'FAMU': famuLogo,
    'FGCU': fgcuLogo,
    'UNF': unfLogo,
    'ASU': asuLogo,
    'Auburn': auburnLogo,
    'CSUF': csufLogo,
    'CSULB': csulbLogo,
    'CMU': cmuLogo,
    'CUNY': cunyLogo,
    'Clemson': clemsonLogo,
    'CSU': csuLogo,
    'Columbia': columbiaLogo,
    'Cornell': cornellLogo,
    'Duke': dukeLogo,
    'GMU': gmuLogo,
    'Georgia Tech': gatechLogo,
    'GSU': gsuLogo,
    'Harvard': harvardLogo,
    'ISU': ilstuLogo,
    'IU': iuLogo,
    'LSU': lsuLogo,
    'MIT': mitLogo,
    'Miami U': miamiohLogo,
    'MSU': msuLogo,
    'NC State': ncsuLogo,
    'Northeastern': northeasternLogo,
    'Northwestern': northwesternLogo,
    'OSU': osuLogo,
    'Penn State': pennstateLogo,
    'Purdue': purdueLogo,
    'RIT': ritLogo,
    'Rutgers': rutgersLogo,
    'SDSU': sdsuLogo,
    'Stanford': stanfordLogo,
    'SUNY': sunyLogo,
    'Syracuse': syracuseLogo,
    'Temple': templeLogo,
    'Texas A&M': tamuLogo,
    'TXST': txstLogo,
    'UA': uaLogo,
    'UArizona': arizonaLogo,
    'UC Davis': ucdavisLogo,
    'UCI': uciLogo,
    'UCSD': ucsdLogo,
    'UChicago': uchicagoLogo,
    'UC': ucincinnatiLogo,
    'CU Boulder': coloradoLogo,
    'UConn': uconnLogo,
    'UDel': udelLogo,
    'UGA': ugaLogo,
    'UH': uhLogo,
    'UIUC': uiucLogo,
    'UIC': uicLogo,
    'UIowa': uiowaLogo,
    'KU': kuLogo,
    'UMD': umdLogo,
    'UMass Amherst': umassLogo,
    'UMich': umichLogo,
    'UMN': umnLogo,
    'Mizzou': missouriLogo,
    'UNL': unlLogo,
    'UNC': uncLogo,
    'UNT': untLogo,
    'OU': ouLogo,
    'UO': uoregonLogo,
    'UPenn': upennLogo,
    'Pitt': pittLogo,
    'USC': uscLogo,
    'UT': utkLogo,
    'UT Austin': utexasLogo,
    'UVA': virginiaLogo,
    'UW-Madison': wiscLogo,
    'Vanderbilt': vanderbiltLogo,
    'VT': vtLogo,
    'WSU': wsuLogo,
    'Wayne State': wayneLogo,
    'UWF': uwfLogo,
    'Florida Poly': floridapolyLogo,
    'NSU': novaLogo,
    'ERAU': erauLogo,
    'Florida Tech': floridatechLogo,
    'UTampa': utampaLogo,
    'Rollins': rollinsLogo,
    'Stetson': stetsonLogo,
    'NCF': ncfLogo,
    'Barry': barryLogo,
    'Eckerd': eckerdLogo,
    'B-CU': bcuLogo,
    'FSC': flsouthernLogo,
    'Lynn': lynnLogo,
    'PBA': pbaLogo,
    'STU': stuLogo,
    'Ringling': ringlingLogo,
    'Ave Maria': avemariaLogo,
    'Fordham': fordhamLogo,
    'Pace': paceLogo,
    'SBU': stonybrookLogo,
    'UB': buffaloLogo,
    'Binghamton': binghamtonLogo,
    'UAlbany': ualbanyLogo,
    'Hofstra': hofstraLogo,
    "St. John's": stjohnsLogo,
    'Pratt': prattLogo,
    'New School': newschoolLogo,
    'FIT': fitnycLogo,
    'YU': yeshivaLogo,
    'Barnard': barnardLogo,
    'Cooper Union': cooperunionLogo,
    'SVA': svaLogo,
    'RPI': rpiLogo,
    'Colgate': colgateLogo,
    'Vassar': vassarLogo,
    'Hamilton': hamiltonLogo,
    'Skidmore': skidmoreLogo,
    'Bard': bardLogo,
    'Union': unioncollegeLogo,
    'Ithaca': ithacaLogo,
    'Marist': maristLogo,
    'Adelphi': adelphiLogo,
    'LIU': liuLogo,
    'NYIT': nyitLogo,
    'Mercy': mercyLogo,
    'Manhattan': manhattanunivLogo,
    'Sarah Lawrence': sarahlawrenceLogo,
    'Stevens': stevensLogo,
    'Princeton': princetonLogo,
    'NJIT': njitLogo,
    'Seton Hall': setonhallLogo,
    'Yale': yaleLogo,
    'Fairfield': fairfieldLogo,

    // Full names
    'University of South Florida': usfLogo,
    'University of Central Florida': ucfLogo,
    'University of Florida': ufLogo,
    'New York University': nyuLogo,
    'University of Washington': uwLogo,
    'University of California Los Angeles': uclaLogo,
    'University of California, Los Angeles': uclaLogo,
    'Florida International University': fiuLogo,
    'Florida Atlantic University': fauLogo,
    'Florida State University': fsuLogo,
    'University of Miami': umLogo,
    'UC Berkeley': calLogo,
    'University of California Berkeley': calLogo,
    'University of California, Berkeley': calLogo,
    'Boston University': buLogo,
    'Florida A&M University': famuLogo,
    'Florida Gulf Coast University': fgcuLogo,
    'University of North Florida': unfLogo,
    'Arizona State University': asuLogo,
    'Auburn University': auburnLogo,
    'California State University, Fullerton': csufLogo,
    'California State University, Long Beach': csulbLogo,
    'Carnegie Mellon University': cmuLogo,
    'City University of New York': cunyLogo,
    'Clemson University': clemsonLogo,
    'Colorado State University': csuLogo,
    'Columbia University': columbiaLogo,
    'Cornell University': cornellLogo,
    'Duke University': dukeLogo,
    'George Mason University': gmuLogo,
    'Georgia Institute of Technology': gatechLogo,
    'Georgia State University': gsuLogo,
    'Harvard University': harvardLogo,
    'Illinois State University': ilstuLogo,
    'Indiana University Bloomington': iuLogo,
    'Iowa State University': iastateLogo,
    'Louisiana State University': lsuLogo,
    'Massachusetts Institute of Technology': mitLogo,
    'Miami University': miamiohLogo,
    'Michigan State University': msuLogo,
    'North Carolina State University': ncsuLogo,
    'Northeastern University': northeasternLogo,
    'Northwestern University': northwesternLogo,
    'Ohio State University': osuLogo,
    'Oregon State University': oregonstateLogo,
    'Penn State University': pennstateLogo,
    'Purdue University': purdueLogo,
    'Rochester Institute of Technology': ritLogo,
    'Rutgers University': rutgersLogo,
    'San Diego State University': sdsuLogo,
    'Stanford University': stanfordLogo,
    'State University of New York': sunyLogo,
    'Syracuse University': syracuseLogo,
    'Temple University': templeLogo,
    'Texas A&M University': tamuLogo,
    'Texas State University': txstLogo,
    'University of Alabama': uaLogo,
    'University of Arizona': arizonaLogo,
    'University of California, Davis': ucdavisLogo,
    'University of California, Irvine': uciLogo,
    'University of California, San Diego': ucsdLogo,
    'University of Chicago': uchicagoLogo,
    'University of Cincinnati': ucincinnatiLogo,
    'University of Colorado Boulder': coloradoLogo,
    'University of Connecticut': uconnLogo,
    'University of Delaware': udelLogo,
    'University of Georgia': ugaLogo,
    'University of Houston': uhLogo,
    'University of Illinois at Urbana-Champaign': uiucLogo,
    'University of Illinois Chicago': uicLogo,
    'University of Iowa': uiowaLogo,
    'University of Kansas': kuLogo,
    'University of Maryland': umdLogo,
    'University of Massachusetts Amherst': umassLogo,
    'University of Michigan': umichLogo,
    'University of Minnesota': umnLogo,
    'University of Missouri': missouriLogo,
    'University of Nebraska-Lincoln': unlLogo,
    'University of North Carolina at Chapel Hill': uncLogo,
    'University of North Texas': untLogo,
    'University of Oklahoma': ouLogo,
    'University of Oregon': uoregonLogo,
    'University of Pennsylvania': upennLogo,
    'University of Pittsburgh': pittLogo,
    'University of South Carolina': scLogo,
    'University of Southern California': uscLogo,
    'University of Tennessee': utkLogo,
    'University of Texas at Austin': utexasLogo,
    'University of Virginia': virginiaLogo,
    'University of Wisconsin-Madison': wiscLogo,
    'Vanderbilt University': vanderbiltLogo,
    'Virginia Tech': vtLogo,
    'Washington State University': wsuLogo,
    'Wayne State University': wayneLogo,
    'University of West Florida': uwfLogo,
    'Florida Polytechnic University': floridapolyLogo,
    'Nova Southeastern University': novaLogo,
    'Embry-Riddle Aeronautical University': erauLogo,
    'Florida Institute of Technology': floridatechLogo,
    'University of Tampa': utampaLogo,
    'Rollins College': rollinsLogo,
    'Stetson University': stetsonLogo,
    'New College of Florida': ncfLogo,
    'Barry University': barryLogo,
    'Eckerd College': eckerdLogo,
    'Bethune-Cookman University': bcuLogo,
    'Florida Southern College': flsouthernLogo,
    'Lynn University': lynnLogo,
    'Palm Beach Atlantic University': pbaLogo,
    'St. Thomas University': stuLogo,
    'Ringling College of Art and Design': ringlingLogo,
    'Ave Maria University': avemariaLogo,
    'Fordham University': fordhamLogo,
    'Pace University': paceLogo,
    'Stony Brook University': stonybrookLogo,
    'University at Buffalo': buffaloLogo,
    'Binghamton University': binghamtonLogo,
    'University at Albany': ualbanyLogo,
    'Hofstra University': hofstraLogo,
    "St. John's University": stjohnsLogo,
    'Pratt Institute': prattLogo,
    'The New School': newschoolLogo,
    'Fashion Institute of Technology': fitnycLogo,
    'Yeshiva University': yeshivaLogo,
    'Barnard College': barnardLogo,
    'School of Visual Arts': svaLogo,
    'Rensselaer Polytechnic Institute': rpiLogo,
    'Colgate University': colgateLogo,
    'Vassar College': vassarLogo,
    'Hamilton College': hamiltonLogo,
    'Skidmore College': skidmoreLogo,
    'Bard College': bardLogo,
    'Union College': unioncollegeLogo,
    'Ithaca College': ithacaLogo,
    'Marist College': maristLogo,
    'Adelphi University': adelphiLogo,
    'Long Island University': liuLogo,
    'New York Institute of Technology': nyitLogo,
    'Mercy University': mercyLogo,
    'Manhattan University': manhattanunivLogo,
    'Sarah Lawrence College': sarahlawrenceLogo,
    'Stevens Institute of Technology': stevensLogo,
    'Princeton University': princetonLogo,
    'New Jersey Institute of Technology': njitLogo,
    'Seton Hall University': setonhallLogo,
    'Yale University': yaleLogo,
    'Fairfield University': fairfieldLogo,
};

export const getUniversityLogo = (name: string, abbreviation?: string): string | undefined => {
    // Prefer full name when abbreviation is ambiguous (ISU / OSU / USC / etc.)
    if (name && UNIVERSITY_LOGOS[name]) {
        return UNIVERSITY_LOGOS[name];
    }
    if (abbreviation && UNIVERSITY_LOGOS[abbreviation]) {
        return UNIVERSITY_LOGOS[abbreviation];
    }
    return undefined;
};
